import rootReducer from 'aster-foundation/core/common/redux/rootReducer';
import { combineReducers } from 'redux';
import MyCartReducer from '../../Epharmacy/MyCart/redux/reducer';
import PdpReducer from '../../Epharmacy/ProductDetails/redux/reducer';
import CheckoutReducer from '../../Epharmacy/Checkout/redux/reducer';
import WaitingRoomReducer from '../../TeleConsultation/VideoCall/WaitingRoom/redux/reducer';
import UserLocationReducer from '../Component/HeaderBelow/redux/reducer';
import MyShoppingListReducer from '../../Epharmacy/MyShoppingList/redux/reducer';
import SearchReducer from 'Epharmacy/SearchResult/redux/reducer';

const appReducers = combineReducers({
  waitingRoomReducer: WaitingRoomReducer,
  userLocationReducer: UserLocationReducer,
  myCartReducer: MyCartReducer,
  pdpReducer: PdpReducer,
  checkoutReducer: CheckoutReducer,
  myShoppingListReducer: MyShoppingListReducer,
  searchReducer: SearchReducer
});

const appReducer = combineReducers({
  ...rootReducer,
  app: appReducers,
});

export default appReducer;
